export const GET_COMMENTS_LIST = 'COMMENTS/GET_COMMENTS'
export const GET_COMMENTS_LIST_FAILED = 'COMMENTS/GET_COMMENTS_LIST_FAILED'
export const GET_COMMENTS_LIST_SUCCESS = 'COMMENTS/GET_COMMENTS_LIST_SUCCESS'
